"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActionsWithoutAccessRightCheck = exports.getAdminActions = exports.getActions = exports.getActionsWithClientIdCheck = exports.ACTIONS = exports.ACTIONS_WITH_AUTH_CHECK = exports.getActionsWithAuthorizationCheck = exports.ACTIONS_WITHOUT_CLIENT_ID_CHECK = exports.ACTIONS_WITHOUT_ACCESS_RIGHT_CHECK = exports.ADMIN_ACTIONS = exports.ACTIONS_WITHOUT_AUTH_CHECK = void 0;
const types_1 = require("../types");
exports.ACTIONS_WITHOUT_AUTH_CHECK = [
    types_1.ACTION_CODE.BASIC,
    types_1.ACTION_CODE.CREATE_SUPER_ADMIN,
    types_1.ACTION_CODE.SUPER_ADMIN,
];
exports.ADMIN_ACTIONS = [
    types_1.ACTION_CODE.CREATE_CLIENT,
    types_1.ACTION_CODE.EDIT_CLIENT,
    types_1.ACTION_CODE.ARCHIVE_CLIENT,
    types_1.ACTION_CODE.RESTORE_CLIENT,
    types_1.ACTION_CODE.DELETE_CLIENT,
];
exports.ACTIONS_WITHOUT_ACCESS_RIGHT_CHECK = [types_1.ACTION_CODE.FETCH_CLIENT];
exports.ACTIONS_WITHOUT_CLIENT_ID_CHECK = [
    ...exports.ADMIN_ACTIONS,
    ...exports.ACTIONS_WITHOUT_ACCESS_RIGHT_CHECK,
];
const getActionsWithAuthorizationCheck = () => {
    const result = [];
    const actions = Object.values(types_1.ACTION_CODE);
    for (let action of actions) {
        if (!exports.ACTIONS_WITHOUT_AUTH_CHECK.includes(action)) {
            result.push(action);
        }
    }
    return result;
};
exports.getActionsWithAuthorizationCheck = getActionsWithAuthorizationCheck;
exports.ACTIONS_WITH_AUTH_CHECK = (0, exports.getActionsWithAuthorizationCheck)();
exports.ACTIONS = [
    ...exports.ACTIONS_WITHOUT_AUTH_CHECK,
    ...exports.ACTIONS_WITH_AUTH_CHECK,
];
const getActionsWithClientIdCheck = () => {
    const result = [];
    for (let action of exports.ACTIONS_WITH_AUTH_CHECK) {
        if (!exports.ACTIONS_WITHOUT_CLIENT_ID_CHECK.includes(action)) {
            result.push(action);
        }
    }
    return result;
};
exports.getActionsWithClientIdCheck = getActionsWithClientIdCheck;
const getActions = () => {
    return exports.ACTIONS;
};
exports.getActions = getActions;
const getAdminActions = () => {
    return exports.ADMIN_ACTIONS;
};
exports.getAdminActions = getAdminActions;
const getActionsWithoutAccessRightCheck = () => {
    return exports.ACTIONS_WITHOUT_ACCESS_RIGHT_CHECK;
};
exports.getActionsWithoutAccessRightCheck = getActionsWithoutAccessRightCheck;
